export default __webpack_public_path__ + "static/media/email-envelope-white.d174d1be.svg";